import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function AfterEmployeeCreationSchedulingStrategyEditor() {
    const { t } = useTranslation();

    return <Stack sx={{gap: 2}} direction="column">
        <Typography variant="caption">
            {t("actionModules.schedulingStrategy.afterEmployeeCreation.description")}
        </Typography>
    </Stack>
}